import { Reducer } from "redux";

import { RequestDetailsResponse } from "../models/Api/AuthorizationDetailsTab";
import { RequestDetailsDispatchTypes } from "../models/DispatchTypes/AuthorizationDetailstab";
import { RequestDetailsActionDispatchTypes } from "../constants/Authorization";

const initialState: RequestDetailsResponse = {
    loading: false,
    response: {
        referralSource: {
            name: "",
            npi: "",
            phone: "",
            fax: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
        },
        orderingPhysician: {
            name: "",
            npi: "",
            phone: "",
            fax: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
        },
        followingPhysician: {
            name: "",
            npi: "",
            phone: "",
            fax: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
        },
    },
    error: null,
};

const RequestDetailsReducer: Reducer<
    RequestDetailsResponse,
    RequestDetailsDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case RequestDetailsActionDispatchTypes.REQUEST_DETAILS_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case RequestDetailsActionDispatchTypes.REQUEST_DETAILS_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case RequestDetailsActionDispatchTypes.REQUEST_DETAILS_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case RequestDetailsActionDispatchTypes.REQUEST_DETAILS_RESET: {
            return initialState;
        }
    }
    return state;
};
export default RequestDetailsReducer;
